import { Badge } from '@/ui-components/Badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui-components/Table'

const getStatusColour = (status: 'active' | 'pending' | 'disabled') => {
  switch (status) {
    case 'active':
      return 'green'
    case 'pending':
      return 'amber'
    case 'disabled':
      return 'gray'
  }
}

type GlobalAccount = {
  id: string
  currency: string
  flag?: string
  country?: string
  accountName?: string
  iban?: string
  accountNumber?: string
  sortCode?: string
  transitNumber?: string
  status: 'active' | 'pending' | 'disabled'
}

type GlobalAccountsProps = {
  accounts: GlobalAccount[]
}

const GlobalAccounts = ({ accounts }: GlobalAccountsProps) => {
  return (
    <div className="overflow-x-auto">
      <Table className="max-w-[calc(100vw-3rem)] lg:max-w-[calc(100vw-20rem)]">
        <TableHead>
          <TableRow>
            <TableHeader>Currency</TableHeader>
            <TableHeader>Bank Location</TableHeader>
            <TableHeader>Name</TableHeader>
            <TableHeader>Account Number</TableHeader>
            <TableHeader>Status</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {accounts.map((acct) => (
            <TableRow
              key={acct.id}
              to={`/global-accounts/${acct.id}`}
            >
              <TableCell className="flex items-center gap-2">
                <span>{acct.flag}</span>
                <span className="text-sm">{acct.currency}</span>
              </TableCell>
              <TableCell className="text-sm text-gray-900 dark:text-gray-100">{acct.country}</TableCell>
              <TableCell className="text-sm text-gray-900 dark:text-gray-100">{acct.accountName}</TableCell>
              <TableCell className="text-sm text-gray-900 dark:text-gray-100">
                {acct.iban || acct.accountNumber || acct.sortCode || acct.transitNumber || '—'}
              </TableCell>
              <TableCell>
                <Badge color={getStatusColour(acct.status)}>{acct.status === 'active' ? 'Active' : 'Pending'}</Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default GlobalAccounts
